import React, { useEffect, useRef, useState } from "react";
import styles from "./style.module.css";
import { useDispatch, useSelector } from "react-redux";
import UseOutSideClick from "../../../../../../helpers/UseOutSideClick";
import lang from "../../../../../../lang/lang";
import { postCreditModal2 } from "../../../../../../store/MainSlice";
import { Link, useNavigate } from "react-router-dom";
import CloseSvg from "../../../../../../assets/SVG/CloseSvg";
import CartLoader from "../../../CartLoader";
const sendedFiles = [];
export default function Agreement({
  fullName,
  agreementInfo,
  activePaymentId,
  close,
  withScroll = true,
}) {
  const [aggreCheckBox, setAggreCheckBox] = useState(false);
  const [aggreCheckBox2, setAggreCheckBox2] = useState(false);
  const [passportInput, setPassportInput] = useState("");

  const [showCreditInfoBlock, setShowCreditInfoBlock] = useState(false);
  const [uploadedFile, setUpladedFile] = useState(null);
  const [uploadedImages, setUploadedImages] = useState([]);

  const [uploadedFileError, setUpladedFileError] = useState(false);
  const [passportInputError, setPassportInputError] = useState(false);
  const [aggreCheckBoxError, setAggreCheckBoxError] = useState(false);
  const [aggreCheckBox2Error, setAggreCheckBox2Error] = useState(false);
  const [thanksModal, setThanksModal] = useState(false);
  const [pending, setPending] = useState(false);
  const navigate = useNavigate();

  const { currentLanguage } = useSelector(({ main }) => main);
  const mainRef = useRef();
  const dispatch = useDispatch();
  UseOutSideClick(mainRef, () => {
    navigate("/");
  });
  useEffect(() => {
    if (withScroll) {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <>
      {pending && <CartLoader />}
      <div
        className={styles.main}
        style={pending ? { display: "none" } : null}
        ref={mainRef}
      >
        <div>
          {!!agreementInfo?.icon && (
            <img
              className={styles.bankLogo}
              src={"https://vlv.am/public/" + agreementInfo?.icon}
             alt="VLV" />
          )}

          <div className={styles.bankText}>
            {activePaymentId == "acba"
              ? "ՀԱՄԱՁԱՅՆԱԳԻՐ Սույնով տալիս եմ իմ համաձայնությունը, որ. • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցումներ կատարի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս: • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում, իսկ գլխավոր վարկային պայմանագրի առկայության դեպքում նաև վերջինիս գործողության ողջ ընթացքում ցանկացած պահի առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ: • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցում կատարի «Նորք» սոցիալական ծառայությունների տեխնոլոգիական և իրազեկման կենտրոն հիմնադրամին, և խնդրում եմ վերջինիս տրամադրել իմ վերաբերյալ ցանկացած տեղեկատվություն, որը կարող է կիրառվել Բանկի կողմից: • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն սեփականության կամ ընդհանուր սեփականության իրավունքով ինձ պատկանող գույքերի վերաբերյալ հարցում կատարի ՀՀ կադաստրի կոմիտե և ստանա սպառիչ տեղեկատվություն իմ գույքային իրավունքների, այդ թվում` դրանց ծագման հիմքերի վերաբերյալ, ինչպես նաև կադաստրային գործից ստանա սեփականության իրավունքի վկայականի, հատակագծի և այլ անհրաժեշտ փաստաթղթերի պատճենները, իմ անունից դիմում ներկայացնի ՀՀ կադաստրի կոմիտե, կատարի անշարժ գույքի նկատմամբ ցանկացած իրավունքի պետական գրանցում, ստանա փաստաթղթեր,կատարի վճարումներ` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը: • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն սեփականության կամ ընդհանուր սեփականության իրավունքով ինձ պատկանող տրանսպորտային միջոցների վերաբերյալ հարցում կատարի ՀՀ Ճանապարհային ոստիկանություն և ստանա սպառիչ տեղեկատվություն տրանսպորտային միջոցների նկատմամբ իմ գույքային իրավունքների, այդ թվում` դրանց ծագման հիմքերի վերաբերյալ, ինչպես նաև ստանա սեփականության իրավունքի վկայականի և այլ անհրաժեշտ փաստաթղթերի պատճենները` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը: • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցում կատարի «Հայաստանի ավտոապահովագրողների բյուրո» ԻԱՄ-ին և ապահովագրական ընկերություններին և ստանա ցանկացած տեղեկատվություն սեփականության իրավունքով ինձ պատկանող տրանսպորտային միջոցների ապահովագրության վերաբերյալ (այդ թվում՝ ապահովադրի և շահառուների վերաբերյալ տեղեկություններ)` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը: • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից ինձ ուղարկվեն ծանուցումներ` «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ի կողմից մատուցվող ծառայությունների հետ կապված ցանկացած տեղեկատվության վերաբերյալ: • Սույնով ծանուցվում եմ, ինչպես նաև տալիս եմ իմ համաձայնությունը, որ «Անձնական տվյալների պաշտպանության մասին» ՀՀ օրենքի համաձայն՝ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն (ՀՀ, ք. Երևան, Արամի 82-84) 50 տարվա ընթացքում հարցումներ կատարի «Էլեկտրոնային կառավարման ենթակառուցվածքների ներդրման գրասենյակ» ՓԲԸ (ԷԿԵՆԳ)` ՀՀ Ոստիկանության բնակչության պետական ռեգիստրի, ՀՀ Արդարադատության նախարարության քաղաքացիական կացության ակտերի գրանցման գործակալության, ՀՀ Ոստիկանության ճանապարհային ոստիկանության, ՀՀ ԱՆ Իրավաբանական անձանց պետական ռեգիստրի, ՀՀ Արդարադատության նախարարության հարկադիր կատարման ծառայության, ՀՀ ԿԱ Պետական եկամուտների կոմիտեի և ՀՀ կադաստրի կոմիտեի տվյալներից իմ վերաբերյալ ցանկացած տեղեկատվություն ստանալու նպատակով, որն օգտագործվելու և ուսումնասիրվելու է ծառայությունների մատուցման հետ կապված ցանկացած գործընթացում, ինչպես նաև իմ անձնական տվյալները «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ի կողմից փոխանցվի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ, ՀՀ կենտրոնական բանկ, պետական իրավասու մարմիններ և այն իրավաբանական անձանց, որոնց կանոնադրական կապիտալում «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն ունի ուղղակի կամ անուղղակի մասնակցություն: Համաձայնությունը/անձնական տվյալները կարող են հետ կանչվել, ուղղվել, ոչնչացվել, իսկ տվյալների մշակումը՝ դադարեցվել իմ գրավոր դիմումի հիման վրա: Գիտակցում եմ, որ տրամադրված տեղեկությունները և տվյալները, կախված դրանց բովանդակությունից, կարող են ազդել «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կայացված համապատասխան որոշման վրա: Սույն համաձայնությունը կարդացել եմ և հավաստում եմ, որ այն ինձ համար ամբողջությամբ հասկանալի և ընդունելի է:"
              : activePaymentId == "ineco"
              ? 'ԱՊՐԱՆՔՆԵՐԻ ԵՎ/ԿԱՄ ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐԻ ԱՊԱՌԻԿ ԿԱՐԳՈՎ ՁԵՌՔԲԵՐՄԱՆ ՖԻՆԱՆՍԱՎՈՐՄԱՆ ՀԱՅՏ ԵՎ ՀԱՄԱՁԱՅՆՈՒԹՅՈՒՆ 1. Սույնով դիմում եմ ապառիկ կարգով ապրանք(ներ)ի և/կամ ծառայություն(ներ)ի ձեռքբերման նպատակով "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից 30.000 – 5.000.000 ՀՀ դրամ գումարի սահմաններում ֆինանսավորում ստանալու համար՝ վերջինիս կողմից սահմանված պայմաններին համապատասխան: 2. Տեղեկացված եմ, որ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից սույն հայտի վերաբերյալ դրական կամ բացասական որոշում կայացնելու համար տեղեկատվության բավարար չլինելու դեպքում անհրաժեշտ է սույն հայտի ներկայացման պահից 3 (երեք) աշխատանքային օրվա ընթացքում ներկայանալ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ՝ ներկայացնելով սույն հայտի՝ ինձ տրված մեկ օրինակը, ինչպես նաև իմ վարկարժանության ստուգման հետագա ընթացքի համար անհրաժեշտ փաստաթղթեր և տեղեկատվություն՝ ըստ պահանջի: Հասկանում և ընդունում եմ, որ սույն կետով սահմանված ժամկետում "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ չներկայանալու դեպքում սույն հայտը կմերժվի "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից: 3. Տեղեկացված եմ, որ սույն հայտը մերժելու մասին որոշում կայացնելու դեպքում "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ն որոշման կայացման օրվանից առավելագույնը 2 (երկու) աշխատանքային օրվա ընթացքում այդ մասին գրավոր ձևով կհայտնի ինձ՝ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի տարածքում թղթային օրինակն առձեռն տրամադրելով: 4. Սույնով տալիս եմ իմ համաձայնությունը, որպեսզի "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից հարցում կատարվի "ԱՔՌԱ Քրեդիտ Ռեփորթինգ" ՓԲԸ և վերջինիս խնդրում եմ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս։ Ինչպես նաև տալիս եմ իմ համաձայնությունը, որպեսզի "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում ցանկացած պահին` առանց ինձ նախապես տեղյակ պահելու, "ԱՔՌԱ Քրեդիտ Ռեփորթինգ" ՓԲԸ-ն "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ։ Գիտակցում եմ, որ տրամադրված տեղեկությունները և տվյալները, կախված դրանց բովանդակությունից կարող են ազդել "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից կայացված համապատասխան որոշման վրա։ Սույն համաձայնությունը կարդացել եմ և հավաստում եմ, որ այն ինձ համար ամբողջությամբ հասկանալի և ընդունելի է։ 5. Սույնով հաստատում եմ, որ սույն փաստաթղթի նախորդ կետով իմ կողմից տրված համաձայնությունն ամբողջ ծավալով տարածվում է նաև ՀՀ կենտրոնական բանկի վարկային ռեգիստրի, "ՆՈՐՔ" սոցիալական ծառայությունների տեխնոլոգիական և իրազեկման կենտրոն հիմնադրամի, հանրային տվյալների բազաների, "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի հետ համագործակցող վարկային բյուրոների և բանկային սպասարկման ոլորտում հաճախորդների վերաբերյալ տվյալներ մշակող անձանց կողմից "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ին իմ ներկա և անցյալ ֆինանսական պարտավորությունների (իսկ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի հետ վարկային (փոխառության և այլն) պայմանագիր կնքվելու դեպքում նաև՝ ապագա ֆինանսական պարտավորությունների) վերաբերյալ տեղեկությունների, ինչպես նաև այլ տվյալների տրամադրման վրա՝ ինչպես սույն համաձայնության տրամադրման պահին, այնպես էլ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում:'
              : null}
          </div>
        </div>
        <span className={styles.title}>
          {lang[currentLanguage].order_num} {agreementInfo?.order_number}
        </span>
        <span className={styles.title}>{fullName}</span>

        <input
          className={styles.passportInput}
          type="text"
          placeholder="Անձնագիր"
          value={passportInput}
          onChange={(e) => setPassportInput(e.target.value)}
          style={
            passportInputError
              ? {
                  borderColor: "#d10000",
                }
              : null
          }
        />

        <div
          className={styles.checkBoxBlock}
          onClick={() => setAggreCheckBox(!aggreCheckBox)}
        >
          <div
            className={styles.checkBox}
            style={
              aggreCheckBox2Error
                ? {
                    borderColor: "#d10000",
                  }
                : null
            }
          >
            <span>
              {aggreCheckBox ? (
                <svg
                  width="9"
                  height="6"
                  viewBox="0 1 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M1 2.5L3.5 5L8 0.5" stroke={"#E31335"}></path>
                </svg>
              ) : null}
            </span>
          </div>
          <span className={styles.checkBoxText}>
            {lang[currentLanguage].i_have_read}
          </span>
        </div>
        <div className={styles.checkBoxBlock}>
          <div
            className={styles.checkBox}
            style={
              aggreCheckBox2Error
                ? {
                    borderColor: "#d10000",
                  }
                : null
            }
            onClick={() => setAggreCheckBox2(!aggreCheckBox2)}
          >
            <span>
              {aggreCheckBox2 ? (
                <svg
                  width="9"
                  height="6"
                  viewBox="0 1 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M1 2.5L3.5 5L8 0.5" stroke={"#E31335"}></path>
                </svg>
              ) : null}
            </span>
          </div>
          <span
            className={styles.checkBoxText}
            dangerouslySetInnerHTML={{
              __html: lang[currentLanguage].acba_score,
            }}
            onClick={() => setShowCreditInfoBlock(!showCreditInfoBlock)}
          ></span>
        </div>
        {showCreditInfoBlock ? (
          <div className={styles.creditInfoBlock}>
            <span className={styles.creditInfoBlockTitle}>
              Վարկային ամփոփ գնահատական
            </span>
            <span className={styles.creditInfoBlockDescription}>
              Տեղեկացնում ենք, որ Ձեր կողմից ներկայացված վարկային դիմումների
              քանակը բացասական ազդեցություն է ունենում Ձեր վարկային ամփոփ
              գնահատականի, մասնավորապես, ՖԱՅԿՈ սքոր գնահատականի վրա։
            </span>
          </div>
        ) : null}
        <span className={styles.addPhotoText}>
          {lang[currentLanguage].add_a_passport_photo}
        </span>

        <label className={styles.uploadBtn}>
          <input
            type="file"
            accept="image/*, application/pdf"
            multiple
            style={{
              width: 0,
              height: 0,
              border: 0,
              outline: 0,
              display: "none",
            }}
            onChange={(e) => {
              const fileArray = Array.from(e.target.files);
              if (e.target.files.length) {
                for (let i = 0; i < e.target.files.length; i++) {
                  sendedFiles.push(e.target.files[i]);
                }
              }

              setUpladedFile(e.target.files);
              fileArray?.forEach((element) => {
                const reader = new FileReader();
                reader.readAsDataURL(element);
                reader.onload = function (e) {
                  const prefixes = [
                    "data:image/jpeg;base64,",
                    "data:image/png;base64,",
                    "data:image/gif;base64,",
                    "data:application/pdf;base64,",
                  ];
                  for (const prefix of prefixes) {
                    if (e.target.result.startsWith(prefix)) {
                      setUploadedImages((prevState) => [
                        ...prevState,
                        e.target.result,
                      ]);
                    }
                  }
                };
              });
            }}
          />
          <span>{lang[currentLanguage].upload_file}</span>
        </label>
        {uploadedFileError && (
          <span
            style={{
              color: "#d10000",
            }}
          >
            {lang[currentLanguage].choose_file}
          </span>
        )}

        <div className={styles.uploadedImagesRow}>
          {uploadedImages.map((img, index) => (
            <div className={styles.uploadedImgContainer}>
              <span
                className={styles.deleteImage}
                onClick={() => {
                  let filteredImages = uploadedImages.filter(
                    (item, i) => index != i
                  );
                  setUploadedImages(filteredImages);

                  sendedFiles = sendedFiles.filter((item, i) => index != i);
                }}
              >
                ✖
              </span>

              <img src={img}  alt="VLV" />
            </div>
          ))}
        </div>
        <div className={styles.uploadFileDesc}>
          <div className={styles.uploadFileDescRow}>
            <div className={styles.step}>
              <span>Քայլ 1</span>
            </div>
            <div className={styles.desc}>
              Նկարում եք Ձեր անձնագիրը և սոց. քարտը ՝ որտեղ հստակ ընթեռնելի
              կերևա անձնագրի գլխավոր էջը(նկարով), վավերականության ժամկետը,
              գրանցման հասցենները, կամ նույնականացման քարտը(ID) 2 կողմից
            </div>
          </div>
          <div className={styles.uploadFileDescRow}>
            <div className={styles.step}>
              <span>Քայլ 2</span>
            </div>
            <div className={styles.desc}>
              Լուսանկարում եք Ձեզ անձնագրի հետ միասին
            </div>
          </div>
          <div className={styles.uploadFileDescRow}>
            <div className={styles.step}>
              <span>Քայլ 3</span>
            </div>
            <div className={styles.desc}>
              Այնուհետև բոլոր նկարները ուղարկում եք aparik@vlv.am էլ. հասցեին
              կամ ուղարկեք Viber, WhatsApp +37496018166 կամ +374 91 767117
              համարին։
            </div>
          </div>
        </div>
        <div
          className={styles.buyBtn}
          onClick={() => {
            setPassportInputError(!passportInput);
            setUpladedFileError(!uploadedFile || !sendedFiles?.length);
            setAggreCheckBoxError(!aggreCheckBox);
            setAggreCheckBox2Error(!aggreCheckBox2);

            if (
              passportInput &&
              uploadedFile &&
              sendedFiles?.length &&
              aggreCheckBox &&
              aggreCheckBox2
            ) {
              setPending(true);
              const sendData = new FormData();
              sendData.append("token", process.env.REACT_APP_TOKEN);
              sendData.append("login", process.env.REACT_APP_LOGIN);
              sendData.append("password", process.env.REACT_APP_PASSWORD);
              sendData.append("credit_info_passport", passportInput);
              sendData.append("image_uploads", uploadedFile);
              sendedFiles.forEach((item, index) => {
                sendData.append("image_uploads_" + index, item);
              });
              sendData.append("order_id", agreementInfo?.order_id);
              sendData.append("img_count", uploadedImages.length);
              window.scrollTo(0, mainRef.current?.offsetTop);
              dispatch(
                postCreditModal2(sendData, () => {
                  setPending(false);
                  setThanksModal(true);
                })
              );
            }
          }}
        >
          <span>{lang[currentLanguage].send}</span>
        </div>
      </div>
      {thanksModal && (
        <div className={styles.thanksModalBg}>
          <div className={styles.thanksModal}>
            <Link to={"/"} className={styles.thanksModalClose}>
              <CloseSvg />
            </Link>
            <img
              className={styles.thanksModalImg}
              src="https://vlv.am/public/img/order_alert.png"
              alt={''}
            />
            <span className={styles.thanksModalTitle}>
              {lang[currentLanguage]?.ushadrutyun}
            </span>
            <span className={styles.thanksModalSubTitle}>
              {lang[currentLanguage]?.order_alert_text}
            </span>
            <Link to={"/"} onClick={close} className={styles.thanksModalBtn}>
              <span>{lang[currentLanguage]?.to_close}</span>
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
